/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebdaythu3Inputs */

const en_placewebdaythu3 = /** @type {(inputs: Placewebdaythu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu`)
};

const de_placewebdaythu3 = /** @type {(inputs: Placewebdaythu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do`)
};

/**
* | output |
* | --- |
* | "Thu" |
*
* @param {Placewebdaythu3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebdaythu3 = /** @type {((inputs?: Placewebdaythu3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebdaythu3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebdaythu3(inputs)
	return de_placewebdaythu3(inputs)
});
export { placewebdaythu3 as "placeWebDayThu" }